import { render, staticRenderFns } from "./GH.vue?vue&type=template&id=9daa2678"
import script from "./GH.vue?vue&type=script&lang=js"
export * from "./GH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports